import moment from 'moment';

export const generateRum = (clientId: string) => {
    return `PRLV-${clientId}-${moment(new Date()).format('YYMMDDHHmmss')}`;
};
